import { CancelFunctions } from 'components/common/types';

export const cancelFunctions: CancelFunctions = {};
